<template>
    <div class="course-detail-container" :class="isMobile?'mobile-course-detail-container':''">
        <page-background />
      <div class="course-detail-route">
        <router-link to="/">
          首页
        </router-link>
        <a-icon type="right"/>
        <span>视频详情</span>
      </div>

        <div class="box" :style="isMobile?{width:'90%',margin:'0 auto'}:{}">
            <div class="course-introduce-box">
                <course-introduce />
            </div>

            <course-info-tab class="course-info-tab" />
        </div>
    </div>

</template>

<script>
    import common from "../../mixin/common";
    import CourseIntroduce from "@views/course/components/CourseIntroduce"
    import CourseInfoTab from "@views/course/components/CourseInfoTab";
    import {DISPATCH_INIT_COURSE_INFO} from "@constants/action-type/course-action-type";

    export default {
        mixins: [common],
        name: "courseDetail",
        components: {
            CourseIntroduce,
            CourseInfoTab
        },
        mounted() {
            this.$store.dispatch(DISPATCH_INIT_COURSE_INFO, {courseId: this.$route.params.courseId});
        }
    }
</script>

<style scoped lang="less">
    .course-introduce-box{
      margin-top: -100px;
    }
    .course-detail-container {
        padding-bottom: 40px;
    }

    // 课程详情页头
    .course-detail-route {
      font-size: 16px;
      padding: 20px 0 15px 20px;
      margin: auto;
      color: #fff;
      width: 1200px;
      height: 164px;
      background-size: 100%;
      background: linear-gradient(90deg, #5782F6 0%, #4683FF 100%);;
      box-shadow: 0px 8px 10px 0px rgba(40,113,234,0.1);
      a{
        color: #fff;
      }
    }

    .course-info-tab {
        margin-top: 20px;
        border-radius: 3px;
    }

    // 移动端样式
    .mobile-course-detail-container {
        padding-bottom: 70px;
    }
</style>
